/* eslint-disable react/prop-types */
import { observer } from "mobx-react";
import Footer from "@/components/footer/Footer";
import Header from "@/components/header/Header";
import SectionsRenderer from '@/components/sections/SectionsRenderer';
import DefaultPageContent from '@/components/page-templates/DefaultPageContent';

const HomePage = observer(({
  pageData,
  featuredProducts,
  sliderProducts,
  crossSellProducts,
}) => {

  return (
    <>
      <Header />
      <main className="pt-[5rem] pd:mt-0">
          {!pageData.acf?.sections || pageData.acf.sections.length === 0 ? (
            <DefaultPageContent pageData={pageData} />
          ) : (
            <SectionsRenderer
              sections={pageData.acf.sections}
              featuredProducts={featuredProducts}
              sliderProducts={sliderProducts}
              crossSellProducts={crossSellProducts}
            />
          )}
      </main>
      <Footer />
    </>
  );
});

export default HomePage;